import React from 'react';
import FormRadio from '@app/component/form/input/radio/FormRadio';
import Meal from '@app/model/market_state/Meal';


const AlertFilterMealsField: React.FunctionComponent<{ form: any }> = ({form}) => {

    return <>
        <p className="text-sm font-semibold leading-6 text-gray-900 mb-2">Meal</p>
        <div className="space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
            <FormRadio name={`filter.meal`} form={form} options={[
                {label: "Any Meal", value: null},
                {label: "Bed Only", value: Meal.NONE},
                {label: "Bed & Breakfast", value: Meal.BREAKFAST},
                {label: "Half Board", value: Meal.HALF_BOARD},
                {label: "Full Board", value: Meal.FULL_BOARD},
                {label: "All Inclusive", value: Meal.ALL_INCLUSIVE}
            ]}/>
        </div>
    </>
}

export default AlertFilterMealsField;
